import { useTranslation } from 'react-i18next';

import { Footer, HeroBackground, Section, SectionText, SectionTitle } from 'components';

const ImpressumPage = () => {
    const { t } = useTranslation();

    return (
        <>
            <HeroBackground background={true}>
                <Section hero={true}>
                    <SectionTitle variant='light' title={t('legal_notice.title')} />
                    <div style={{ whiteSpace: 'pre-line' }}>
                        <SectionText text={t('legal_notice.content')} />
                    </div>
                </Section>
            </HeroBackground>
            <Footer />
        </>
    )
}

export default ImpressumPage;